/**
 * 英文語言資源
 */

export const enResources = {
  translation: {
    // 認證相關
    auth: {
      login: "Login with Google",
      login_with: "Login with",
      logout: "Logout",
      login_failed: "Login Failed: Please try again later",
      terms_agreement:
        "By logging in, you agree to our <1>Terms of Service</1> and <3>Privacy Policy</3>",
    },
    // 使用者相關
    user: {
      profile: "Profile",
      welcome: "Welcome, {{name}}!",
    },
    // 頁面相關
    pages: {
      protected: "Protected Page",
    },
    // 狀態相關
    status: {
      loading: "Loading...",
      error_occurred: "An error occurred",
      error_message:
        "The application encountered a problem. Please refresh the page or try again later.",
    },
    // 錯誤相關
    errors: {
      page_not_found: "Page Not Found",
      page_not_found_message:
        "The page you are looking for doesn't exist or has been moved.",
      permission_denied: "Permission Denied",
      permission_denied_message:
        "You don't have permission to access this page. If you believe this is an error, please contact your administrator.",
      go_back: "Go Back",
      contact_admin: "Contact Administrator",
    },
    // 操作相關
    actions: {
      refresh_page: "Refresh Page",
      language_toggle: "Switch Language",
    },
    // 共用按鈕和文字
    common: {
      back_to_home: "Back to Home",
      go_to_profile: "Go to Profile",
    },
    // 主題相關
    theme: {
      switchToLight: "Switch to light mode",
      switchToDark: "Switch to dark mode",
      light_mode: "Light Mode",
      dark_mode: "Dark Mode",
    },
    // 法律相關
    legal: {
      privacy_policy: "Privacy Policy",
      terms_of_service: "Terms of Service",
      back_to_login: "Back to Login",
      last_updated: "Last updated: May 5, 2025",
    },
    // 首頁相關
    home: {
      title: "Home",
      overview: "Overview",
      activity: "Activity",
      notifications: "Notifications",
    },
    // 網站相關
    website: {
      title: "Website",
      pages: "Pages",
      templates: "Templates",
      domains: "Domains",
    },
    // SEO 相關
    seo: {
      title: "SEO",
      overview: "Overview",
      keywords: "Keywords",
      performance: "Performance",
    },
    // 資源相關
    resources: {
      title: "Resources",
      media: "Media",
      documents: "Documents",
      uploads: "Uploads",
    },
    // 分析相關
    analytics: {
      title: "Analytics",
      overview: "Overview",
      traffic: "Traffic",
      conversion: "Conversion",
    },
    // 行銷相關
    marketing: {
      title: "Marketing",
      campaigns: "Campaigns",
      email: "Email",
      social: "Social Media",
    },
    // 專案相關
    project: {
      title: "Projects",
      create: "Create Project",
      edit: "Edit Project",
      delete: "Delete Project",
      details: "Project Details",
      list: "Project List",
      templates: "Project Templates",
    },
    // 設定相關
    settings: {
      title: "Settings",
      account: "Account",
      billing: "Billing",
      team: "Team",
    },
    // 任務相關
    task: {
      title: "Tasks",
      create: "Create Task",
      edit: "Edit Task",
      delete: "Delete Task",
      details: "Task Details",
    },
    // 聊天相關
    chat: {
      title: "Chat",
      page_chat: "Page Chat",
      project_chat: "Project Chat",
      type_message: "Type your message here...",
      send: "Send",
      no_messages: "No messages yet",
      start_conversation: "Start a conversation with Glow Assistant",
      load_error: "Failed to load chat messages",
      send_error: "Failed to send message",
      no_context: "No chat context specified",
      user_info_failed: "Failed to get user information",
      building_assistant: "Building Assistant",
      assistant_description: "Get help with your website building process",
      suggestions: "Suggestions",
      info: "Info",
      available_suggestions: "Available Suggestions",
      no_suggestions: "No suggestions available",
      ask_for_suggestions: "Ask the assistant for suggestions",
      apply_suggestion: "Apply",
      current_context: "Current Context",
      context_page: "Page ID: {{id}}",
      context_project: "Project ID: {{id}}",
      assistant_capabilities: "Assistant Capabilities",
      quick_reply: {
        help: "How can you help me?",
        suggestions: "Give me suggestions",
        next_steps: "What should I do next?",
      },
      capabilities: {
        suggestions: "Provide design and content suggestions",
        questions: "Answer questions about website building",
        content: "Help generate website content",
      },
      suggestion_examples: {
        layout: {
          title: "Improve Homepage Layout",
          description:
            "Optimize your homepage layout for better user engagement",
        },
        content: {
          title: "Add Compelling Content",
          description: "Create engaging content for your about section",
        },
        design: {
          title: "Enhance Visual Design",
          description:
            "Improve color scheme and typography for better brand identity",
        },
      },
    },
  },
};
